import { format } from 'date-fns';
import React, { useEffect } from 'react';

import * as S from './styles';

export function MessagesTable({ message, statusPropose, operationConclusion }) {
  if (operationConclusion[0]?.antecipacaoConclusaoId <= 0 || statusPropose) {
    return null;
  }
  return (
    operationConclusion?.[0]?.antecipacaoConclusaoId > 0 && (
      <S.MessageContainer>
        <S.TableTitleHeader>
          <h3 className="operation-title">Antecipação - Resposta do Fornecedor</h3>
        </S.TableTitleHeader>
        <S.MessageBody>
          <p className="message-text">
            {operationConclusion?.[0]?.conclusao} por {operationConclusion?.[0]?.nome}
          </p>
          <p className="message-text">
            {format(new Date(operationConclusion[0]?.dataRegistro), 'dd/MM/yy HH:mm')}
            <span className="message-ip">IP: {operationConclusion[0]?.ip}</span>
          </p>
          {operationConclusion[0]?.mensagem && (
            <p className="message-text">Mensagem: {operationConclusion[0]?.mensagem}</p>
          )}
          {operationConclusion[0]?.boletosEmitidos != 'NaoSeAplica' && (
            <p className="message-text"
              style={{ color: operationConclusion[0]?.boletosEmitidos == 'Emitidos' ?
              '#ff4646' : '#232d64'}}>
              Boletos {operationConclusion[0]?.boletosEmitidos == 'Emitidos' ?
              <span>Emitidos</span> :
              <span>Não Emitidos</span>}
            </p>
          )}
          {operationConclusion[0]?.aceitaAbatimentosDescontos != 'NaoSeAplica' && (
            <p className="message-text"
              style={{ color: operationConclusion[0].aceitaAbatimentosDescontos == 'NaoAceita' ?
              '#ff4646' : '#232d64'}}>
                {operationConclusion[0].aceitaAbatimentosDescontos == 'NaoAceita' ?
                'Não Aceita' : 'Aceita'} Abatimentos/Descontos
            </p>
          )}
        </S.MessageBody>
      </S.MessageContainer>
    )
  );
}
